import Layout from './pages/Layout'

import Home from './pages/home'
import SetShortcuts from './pages/home/SetShortcuts'
import AdvertisementList from './pages/home/AdvertisementList'
import Advertisement from './pages/home/Advertisement'
import Elearning from './pages/third-party/Elearning'

import Login from './pages/login/Login'
import GestureLogin from './pages/login/GestureLogin'
import GestureSet from './pages/login/GestureSet'

import Customer from './pages/customer'
import CustomerList from './pages/customer/List'
import CustomerApply from './pages/customer/Apply'
import CustomerDetail from './pages/customer/Detail'

import Order from './pages/order'
import OrderList from './pages/order/List'
import OrderDetail from './pages/order/Detail'

import Logistics from './pages/order/logistics'
import LogisticsQueryResult from './pages/order/logistics/QueryResult'

import Stock from './pages/order/stock'
import StockQueryResult from './pages/order/stock/QueryResult'

import UrgentOrder from './pages/care/urgent-order'
import UrgentOrderList from './pages/care/urgent-order/List'
import OrderUrgernDetail from './pages/care/urgent-order/Detail'
import UrgentOrderApply from './pages/care/urgent-order/Apply'

import SpecialDelivery from './pages/care/special-delivery'
import SpecialDeliveryList from './pages/care/special-delivery/List'
import SpecialDeliveryDetail from './pages/care/special-delivery/Detail'
import SpecialDeliveryApply from './pages/care/special-delivery/Apply'

import Profile from './pages/profile'
import Userinfo from './pages/profile/Userinfo'
import VersionInfo from './pages/profile/VersionInfo'
import Feedback from './pages/third-party/Feedback'
import ChangePassword from './pages/profile/ChangePassword'
import Manual from './pages/profile/Manual.vue'

export default [
  {
    name: 'layout',
    path: '/',
    redirect: { name: 'home' },
    component: Layout,
    children: [
      {
        name: 'home',
        path: '/home',
        component: Home
      },
      {
        name: 'order',
        path: '/order',
        component: Order,
        meta: { auth: 'Order' }
      },
      {
        name: 'logistics',
        path: '/logistics',
        component: Logistics,
        meta: { auth: 'OutBoundLogistics' }
      },
      {
        name: 'stock',
        path: '/stock',
        component: Stock,
        meta: { auth: 'Stock' }
      },
      {
        name: 'customer',
        path: '/customer',
        component: Customer,
        meta: { auth: 'SICustomer_DBQuery' }
      },
      {
        name: 'urgent-order',
        path: '/urgent-order',
        component: UrgentOrder,
        meta: { auth: 'GreenChannelUrgentOrder' }
      },
      {
        name: 'special-delivery',
        path: '/special-delivery',
        component: SpecialDelivery,
        meta: { auth: 'SpecialLogistics' }
      },
      {
        name: 'profile',
        path: '/profile',
        component: Profile
      }
    ]
  },
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: { parentName: 'home' }
  },
  {
    name: 'gesture-login',
    path: '/gesture-login',
    component: GestureLogin,
    meta: { parentName: 'home' }
  },
  // those page will keep alive and use page stack
  // see code in App.vue
  // they should always be at the top level of routes
  // because the keep alive stack use route.matched[0].components.default.name
  // to record component names from Vue <keep-alive /> component
  {
    name: 'set-shortcuts',
    path: '/set-shortcuts',
    component: SetShortcuts,
    meta: { parentName: 'home' }
  },
  {
    name: 'advertisement-list',
    path: '/advertisement-list',
    component: AdvertisementList,
    meta: { parentName: 'home' }
  },
  {
    name: 'advertisement',
    path: '/advertisement',
    component: Advertisement,
    meta: { parentName: 'advertisement-list' }
  },
  {
    name: 'elearning',
    path: '/elearning',
    component: Elearning,
    meta: { parentName: 'home', auth: 'Patterns' }
  },
  {
    name: 'gesture-set',
    path: '/gesture-set',
    component: GestureSet,
    meta: { parentName: 'home' }
  },
  {
    name: 'customer-list',
    path: '/customer-list',
    component: CustomerList,
    meta: { parentName: 'customer' }
  },
  {
    name: 'customer-apply',
    path: '/customer-apply',
    component: CustomerApply,
    meta: { parentName: 'customer-list' }
  },
  {
    name: 'customer-detail',
    path: '/customer-detail',
    component: CustomerDetail,
    meta: { parentName: 'customer-list' }
  },
  {
    name: 'urgent-order-list',
    path: '/urgent-order-list',
    component: UrgentOrderList,
    meta: { parentName: 'urgent-order' }
  },
  {
    name: 'urgent-order-detail',
    path: '/urgent-order-detail',
    component: OrderUrgernDetail,
    meta: { parentName: 'urgent-order-list' }
  },
  {
    name: 'urgent-order-apply',
    path: '/urgent-order-apply',
    component: UrgentOrderApply,
    meta: { parentName: 'order-detail' }
  },
  {
    name: 'special-delivery-list',
    path: '/special-delivery-list',
    component: SpecialDeliveryList,
    meta: { parentName: 'special-delivery' }
  },
  {
    name: 'special-delivery-detail',
    path: '/special-delivery-detail',
    component: SpecialDeliveryDetail,
    meta: { parentName: 'special-delivery-list' }
  },
  {
    name: 'special-delivery-apply',
    path: '/special-delivery-apply',
    component: SpecialDeliveryApply,
    meta: { parentName: 'special-delivery' }
  },
  {
    name: 'order-list',
    path: '/order-list',
    component: OrderList,
    meta: { parentName: 'order' }
  },
  {
    name: 'order-detail',
    path: '/order-detail',
    component: OrderDetail,
    meta: { parentName: 'order-list' }
  },
  {
    name: 'stock-query-result',
    path: '/stock-query-result',
    component: StockQueryResult,
    meta: { parentName: 'stock' }
  },
  {
    name: 'logistics-query-result',
    path: '/logistics-query-result',
    component: LogisticsQueryResult,
    meta: { parentName: 'logistics' }
  },
  {
    name: 'feedback',
    path: '/feedback',
    component: Feedback,
    meta: { parentName: 'home', auth: 'QuestionFeedBack' }
  },
  {
    name: 'userinfo',
    path: '/userinfo',
    component: Userinfo,
    meta: { parentName: 'profile' }
  },
  {
    name: 'version-info',
    path: '/version-info',
    component: VersionInfo,
    meta: { parentName: 'profile' }
  },
  {
    name: 'manual',
    path: '/manual',
    component: Manual,
    meta: { parentName: 'profile' }
  },
  {
    name: 'change-password',
    path: '/change-password',
    component: ChangePassword,
    meta: { parentName: 'userinfo' }
  },
  {
    name: 'favorite-order-list',
    path: '/favorite-order-list',
    component: OrderList,
    meta: { parentName: 'profile', auth: 'Order' }
  },
  {
    name: 'favorite-order-detail',
    path: '/favorite-order-detail',
    component: OrderDetail,
    meta: { parentName: 'favorite-order-list', auth: 'Order' }
  }
]
